import { baseApi } from "./baseApi";

const VENDOR_PROFILE_BASE_URL = "/vendor-profile";

export const vendorProfileApi = baseApi.injectEndpoints({
  tagTypes: ["VendorProfile"],

  endpoints: (builder) => ({
    createVendorProfile: builder.mutation({
      query: (payload) => ({
        url: `${VENDOR_PROFILE_BASE_URL}`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "VendorProfile", id: "LIST" },
      ],
    }),

    createVendorDocuments: builder.mutation({
      query: (payload) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/document`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "VendorProfile", id: "LIST" }],
    }),

    getVendorProfileList: builder.query({
      query: (params) => ({
        url: `${VENDOR_PROFILE_BASE_URL}`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({
              type: "VendorProfile",
              id: _id,
            })),
            { type: "VendorProfile", id: "LIST" },
          ]
          : [{ type: "VendorProfile", id: "LIST" }],
    }),

    getVendorProfileListForExport: builder.query({
      query: (params) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/listVendorProfilesForExcelExport`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({
              type: "VendorProfile",
              _id,
            })),
            { type: "VendorProfile", id: "LIST" },
          ]
          : [{ type: "VendorProfile", id: "LIST" }],
    }),
    getVendorDocumentsList: builder.query({
      query: (params) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/list`,
        params,
      }),
      providesTags: (result) =>
        result && Array.isArray(result.data)
          ? [
            ...result.data.map(({ _id }) => ({
              type: "VendorProfile",
              id: _id,
            })),
            { type: "VendorProfile", id: "LIST" },
          ]
          : [{ type: "VendorProfile", id: "LIST" }],
    }),

    getActiveVendorProfilesList: builder.query({
      query: (params) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/active`,
        params,
      }),

      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({
              type: "VendorProfile",
              _id,
            })),
            { type: "VendorProfile", id: "LIST" },
          ]
          : [{ type: "VendorProfile", id: "LIST" }],
    }),

    getVendorProfileDetail: builder.query({
      query: (id) => `${VENDOR_PROFILE_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "VendorProfile", id },
        { type: "VendorProfile", id: "LIST" },
      ],
    }),

    getVendorProfileByUserId: builder.query({
      query: (userId) => `${VENDOR_PROFILE_BASE_URL}/user/${userId}`,
      providesTags: (result, error, userId) => [
        { type: "VendorProfile", id: userId },
        { type: "VendorProfile", id: "LIST" },
      ],
    }),

    getActiveVendorProfileByUserId: builder.query({
      query: (userId) => `${VENDOR_PROFILE_BASE_URL}/active/user/${userId}`,
      providesTags: (result, error, userId) => [
        { type: "VendorProfile", id: userId },
        { type: "VendorProfile", id: "LIST" },
      ],
    }),

    getVendorDocumentsDetail: builder.query({
      query: ({ id, documentId }) =>
        `${VENDOR_PROFILE_BASE_URL}/${id}/documents/${documentId}`,
      providesTags: (result, error, id) => [
        { type: "VendorProfile", id },
        { type: "VendorProfile", id: "LIST" },
      ],
    }),

    updateVendorProfile: builder.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;

        return {
          url: `${VENDOR_PROFILE_BASE_URL}/${_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "VendorProfile", _id },
        { type: "VendorProfile", id: "LIST" },
      ],
    }),
    updateVendorDocuments: builder.mutation({
      query: (payload) => {
        const { _id, documentId, ...body } = payload;
        return {
          url: `${VENDOR_PROFILE_BASE_URL}/${_id}/documents/${documentId}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "VendorProfile", id: _id },
        { type: "VendorProfile", id: "LIST" },
      ],
    }),

    createVendorProfileAddresses: builder.mutation({
      query: (payload) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/address`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "VendorProfile", id: "LIST" }],
    }),

    updateVendorProfileAddresses: builder.mutation({
      query: (payload) => {
        const { _id, addressId, vendorId, ...body } = payload;
        return {
          url: `${VENDOR_PROFILE_BASE_URL}/${vendorId}/address/${_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "VendorProfile", id: _id },
        { type: "VendorProfile", id: "LIST" },
      ],
    }),

    getVendorProfileAddressesList: builder.query({
      query: (params) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/address`,
        params,
      }),
      providesTags: (result) =>
        result && Array.isArray(result.data)
          ? [
            ...result.data.map(({ _id }) => ({
              type: "VendorProfile",
              id: _id,
            })),
            { type: "VendorProfile", id: "LIST" },
          ]
          : [{ type: "VendorProfile", id: "LIST" }],
    }),

    getDdlVendorProfile: builder.query({
      query: (params) => ({ url: `${VENDOR_PROFILE_BASE_URL}/ddl`, params }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({
              type: "VendorProfile",
              _id,
            })),
            { type: "VendorProfile", id: "LIST" },
          ]
          : [{ type: "VendorProfile", id: "LIST" }],
    }),
    getDdlVendorProfileForVendorTicket: builder.query({
      query: (params) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/ddlVendorProfileForVendorTicket`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({
              type: "VendorProfile",
              _id,
            })),
            { type: "VendorProfile", id: "LIST" },
          ]
          : [{ type: "VendorProfile", id: "LIST" }],
    }),

    getVendorWithActiveShipments: builder.query({
      query: (params) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/vendorWithActiveShipments`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({
              type: "VendorProfile",
              _id,
            })),
            { type: "VendorProfile", id: "LIST" },
          ]
          : [{ type: "VendorProfile", id: "LIST" }],
    }),

    createVendorBankDetails: builder.mutation({
      query: (payload) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/bankdetails`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "VendorProfile", id: "LIST" }],
    }),

    updateVendorBankDetails: builder.mutation({
      query: (payload) => {
        const { _id, vendorId, ...body } = payload;
        return {
          url: `${VENDOR_PROFILE_BASE_URL}/${vendorId}/bankdetails/${_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "VendorProfile", id: _id },
        { type: "VendorProfile", id: "LIST" },
      ],
    }),

    createVendorProfileLimit: builder.mutation({
      query: (payload) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/limit`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "VendorProfile", id: "LIST" }],
    }),

    updateVendorProfileLimit: builder.mutation({
      query: (payload) => {
        const { vendorId, ...body } = payload;
        return {
          url: `${VENDOR_PROFILE_BASE_URL}/${vendorId}/limit`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { vendorId }) => [
        { type: "VendorProfile", id: vendorId },
        { type: "VendorProfile", id: "LIST" },
      ],
    }),

    addVendorBankDetails: builder.mutation({
      query: (payload) => {
        const { vendorId, ...body } = payload;
        return {
          url: `${VENDOR_PROFILE_BASE_URL}/${vendorId}/addVendorBankDetails`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "VendorProfile", id: "LIST" },
      ],
    }),

    updateVendorProfileStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/${id}/status`,

        method: "PUT",
        body: { status },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "VendorProfile", id },
        { type: "VendorProfile", id: "LIST" },
      ],
    }),

    getVendorBankDetailsList: builder.query({
      query: (params) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/bankdetails`,
        params,
      }),
      providesTags: (result) =>
        result && Array.isArray(result.data)
          ? [
            ...result.data.map(({ _id }) => ({
              type: "VendorProfile",
              id: _id,
            })),
            { type: "VendorProfile", id: "LIST" },
          ]
          : [{ type: "VendorProfile", id: "LIST" }],
    }),
    searchVendors: builder.query({
      query: ({ account, entity, query }) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/search`,
        params: { account, entity, query },
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({
              type: "VendorProfile",
              _id,
            })),
            { type: "VendorProfile", id: "SEARCH" },
          ]
          : [{ type: "VendorProfile", id: "SEARCH" }],
    }),
    getVendorProfilesByVendorId: builder.query({
      query: (vendorId) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/by-vendor/${vendorId}`,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({ type: "VendorProfile", _id })),
            { type: "VendorProfile", id: "BY_VENDOR" },
          ]
          : [{ type: "VendorProfile", id: "BY_VENDOR" }],
    }),
    listVendorShipments: builder.query({
      query: (params) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/${params.vendorId}/shipments`,
        params,
      }),
      providesTags: (_result, _error, { _id }) => [
        { type: "VendorProfile", id: _id },
        { type: "VendorProfile", id: "LIST" },
      ],
    }),

    listVendorPricings: builder.query({
      query: ({ vendorId, page, limit, paymentStatus, fromDate, toDate, keyword }) => {
        // Defensive: ensure vendorId is a string to avoid [object Object] in URL
        const safeVendorId =
          vendorId && typeof vendorId === "object"
            ? vendorId._id || vendorId.id || String(vendorId)
            : vendorId;
        return {
          url: `${VENDOR_PROFILE_BASE_URL}/${safeVendorId}/pricings`,
          params: {
            page,
            limit,
            ...(paymentStatus && paymentStatus !== "All" && { paymentStatus }),
            ...(fromDate && fromDate !== "null" && { fromDate }),
            ...(toDate && toDate !== "null" && { toDate }),
            ...(keyword && keyword.trim() && { keyword: keyword.trim() }),
          },
        };
      },
      providesTags: (_result, _error, { vendorId }) => [
        { type: "VendorProfile", id: vendorId },
        { type: "VendorProfile", id: "LIST" },
      ],
    }),

    getVendorPricingSummary: builder.query({
      query: ({ vendorId, fromDate, toDate }) => {
        // Defensive: ensure vendorId is a string to avoid [object Object] in URL
        const safeVendorId =
          vendorId && typeof vendorId === "object"
            ? vendorId._id || vendorId.id || String(vendorId)
            : vendorId;
        return {
          url: `${VENDOR_PROFILE_BASE_URL}/${safeVendorId}/pricings/summary`,
          params: {
            ...(fromDate && fromDate !== "null" && { fromDate }),
            ...(toDate && toDate !== "null" && { toDate }),
          },
        };
      },
      providesTags: (_result, _error, { vendorId }) => [
        { type: "VendorProfile", id: vendorId },
      ],
    }),

    // New ledger endpoints
    listVendorLedger: builder.query({
      query: ({ vendorId, page, limit }) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/${vendorId}/ledger`,
        params: { page, limit },
      }),
      transformResponse: (response) => ({
        data: response.data,
        totalItems: response.totalItems,
      }),
      providesTags: (_result, _error, { vendorId }) => [
        { type: "VendorLedger", id: vendorId },
        { type: "VendorLedger", id: "LIST" },
      ],
    }),

    // New endpoint for COD Transfers
    listVendorCodTransfers: builder.query({
      query: ({ vendorId, page, limit }) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/${vendorId}/cod-transfers`,
        params: { page, limit },
      }),
      transformResponse: (response) => ({
        data: response.data,
        totalItems: response.totalItems,
      }),
      providesTags: (_result, _error, { vendorId }) => [
        { type: "VendorLedger", id: vendorId },
        { type: "VendorLedger", id: "LIST" },
      ],
    }),

    bulkOrderCancelActiveShipment: builder.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;
        return {
          url: `${VENDOR_PROFILE_BASE_URL}/bulkCancelShipment`,
          method: "POST",
          body,
        };
      },

      invalidatesTags: (result, error, { id }) => [
        { type: "Order", id },
        { type: "Order", id: "LIST" },
      ],
    }),

    getCancelEligibleShipments: builder.query({
      query: (params) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/cancel-eligible`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({
              type: "Shipment",
              _id,
            })),
            { type: "Shipment", id: "LIST" },
          ]
          : [{ type: "Shipment", id: "LIST" }],
    }),

    createVendorServiceBranches: builder.mutation({
      query: (payload) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/serviceBranches`,
        method: "POST",
        body: payload,
      }),

      invalidatesTags: [{ type: "VendorProfile", id: "LIST" }],
    }),

    listVendorServiceBranches: builder.query({
      query: ({ vendorId, page, limit, ...params }) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/${vendorId}/service-branches`,
        params: { page, limit, ...params },
      }),
      providesTags: (_result, _error, { vendorId }) => [
        { type: "Vendor", id: vendorId },
        { type: "Vendor", id: "LIST" },
      ],
    }),

    updateVendorServiceBranches: builder.mutation({
      query: ({ vendorId, branches }) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/${vendorId}/service-branches`,
        method: "PUT",
        body: { branches },
      }),
      invalidatesTags: (_result, _error, { vendorId }) => [
        { type: "Vendor", id: vendorId },
        { type: "Vendor", id: "LIST" },
      ],
    }),
    createVendorShippingRate: builder.mutation({
      query: ({ vendorId, ...body }) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/${vendorId}/shipping-rate`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "VendorProfile", id: "LIST" }],
    }),
    getVendorShippingRate: builder.query({
      query: ({ vendorId, page = 1, limit = 10, ...params }) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/${vendorId}/shipping-rate`,
        params: {
          page,
          limit,
          ...params,
        },
      }),

      providesTags: (_result, _error, { vendorId }) => [
        { type: "VendorProfile", id: vendorId },
        { type: "VendorProfile", id: "LIST" },
      ],
    }),

    updateVendorShippingRate: builder.mutation({
      query: ({ vendorId, rateId, ...body }) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/${vendorId}/shipping-rate/${rateId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: [{ type: "VendorProfile", id: "LIST" }],
    }),

    getVendorProfilesByVendorStaffId: builder.query({
      query: (vendorStaffId) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/by-vendor-staff/${vendorStaffId}`,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({ type: "VendorProfile", _id })),
            { type: "VendorProfile", id: "BY_VENDOR_STAFF" },
          ]
          : [{ type: "VendorProfile", id: "BY_VENDOR_STAFF" }],
    }),
    getVendorPaymentDetails: builder.query({
      query: ({ tab, fromDate, toDate }) => ({
        url: `${VENDOR_PROFILE_BASE_URL}/payment-details`,
        params: { tab, fromDate, toDate },
      }),
    }),
  }),
});

export const {
  useGetVendorProfileListQuery,
  useLazyGetVendorProfileListQuery,
  useLazyGetVendorProfileListForExportQuery,
  useLazyGetVendorDocumentsListQuery,
  useLazyGetActiveVendorProfilesListQuery,
  useGetVendorProfileDetailQuery,
  useGetVendorProfileByUserIdQuery,
  useGetActiveVendorProfileByUserIdQuery,

  useGetVendorDocumentsDetailQuery,
  useCreateVendorProfileMutation,
  useAddVendorBankDetailsMutation,
  useCreateVendorDocumentsMutation,
  useUpdateVendorProfileMutation,
  useUpdateVendorDocumentsMutation,
  useUpdateVendorProfileStatusMutation,
  useGetCancelEligibleShipmentsQuery,
  useCreateVendorProfileAddressesMutation,
  useUpdateVendorProfileAddressesMutation,
  useGetVendorProfileAddressesListQuery,
  useLazyGetVendorProfileAddressesListQuery,
  useLazyGetVendorPricingSummaryQuery,
  useCreateVendorBankDetailsMutation,
  useCreateVendorProfileLimitMutation,

  useUpdateVendorBankDetailsMutation,
  useUpdateVendorProfileLimitMutation,

  useGetVendorBankDetailsListQuery,
  useLazyGetVendorBankDetailsListQuery,
  useGetDdlVendorProfileQuery,
  useLazyGetDdlVendorProfileQuery,
  useLazyGetDdlVendorProfileForVendorTicketQuery,
  useLazyGetVendorWithActiveShipmentsQuery,
  //search
  useLazySearchVendorsQuery,
  useBulkOrderCancelActiveShipmentMutation,
  useLazyListVendorShipmentsQuery,
  useLazyListVendorPricingsQuery,
  useLazyListVendorLedgerQuery,
  useLazyListVendorCodTransfersQuery,
  useLazyGetVendorProfilesByVendorIdQuery,

  // vendor service branch
  useCreateVendorServiceBranchesMutation,
  useUpdateVendorServiceBranchesMutation,
  useLazyListVendorServiceBranchesQuery,

  useGetVendorShippingRateQuery,
  useLazyGetVendorShippingRateQuery,
  useCreateVendorShippingRateMutation,
  useUpdateVendorShippingRateMutation,
  useLazyGetVendorProfilesByVendorStaffIdQuery,
  useLazyGetVendorPaymentDetailsQuery,
} = vendorProfileApi;
